import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AsyncImg from '../AsyncImg';

const LazyLoadImgs = ({ images, batchSize, children }) => {
  const [loadedImages, setLoadedImages] = useState(0);

  return images.map((image, index) => (
    <AsyncImg
      key={image.id || image.src}
      src={image.src}
      alt={image.alt}
      onLoad={() => {
        setLoadedImages(num => num + 1);
      }}
      onError={() => {
        setLoadedImages(num => num + 1);
      }}
      canLoad={index <= loadedImages + batchSize}
    >
      {children}
    </AsyncImg>
  ));
};

LazyLoadImgs.propTypes = {
  children: PropTypes.node,
  images: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  ).isRequired,
  batchSize: PropTypes.number,
};

LazyLoadImgs.defaultProps = {
  batchSize: 1,
  children: undefined,
};

export default LazyLoadImgs;
